
export const sliceIn2 = (arr) => [
    arr.slice(0, Math.ceil(arr.length / 2)),
    arr.slice(Math.ceil(arr.length / 2), arr.length)
]